module.exports = __webpack_public_path__ + "media/access/teachers-3c1dc2d1.png";